import React from 'react'

function NotAvailble() {
    return (
        <div style={{display:"flex",justifyContent:'center',alignItems:'center'}}>
            Please Verify your Account to play quiz and earn coins
        </div>
    )
}

export default NotAvailble
